/*!
 * This file was generated by jce-tools 
 */

export var HUYA = HUYA || {};

HUYA.GetPCDownloaderbyHttpRequestReq = function () {
  this.sChannel = "";
};

HUYA.GetPCDownloaderbyHttpRequestReq.prototype.readFrom = function (is) {
  this.sChannel = is.readString(0, false, this.sChannel);
};

HUYA.GetPCDownloaderbyHttpRequestReq.prototype.writeTo = function (os) {
  os.writeString(0, this.sChannel);
};

HUYA.GetPCDownloaderbyHttpRequestReq.prototype._clone = function () {
  return new HUYA.GetPCDownloaderbyHttpRequestReq();
};
HUYA.GetPCDownloaderbyHttpRequestReq.prototype._write = function (
  os,
  tag,
  value
) {
  os.writeStruct(tag, value);
};
HUYA.GetPCDownloaderbyHttpRequestReq.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.GetPCDownloaderbyHttpRequestRsp = function () {
  this.DownloadUrl = "";
  this.Md5 = "";
  this.Version = "";
  this.LaunchCommand = "";
  this.DesktopIconUrl = "";
  this.CefDownloadUrl = "";
  this.CefMd5 = "";
  this.StartExternal = 0;
  this.lLatestUpdateTime = 0;
};

HUYA.GetPCDownloaderbyHttpRequestRsp.prototype.readFrom = function (is) {
  this.DownloadUrl = is.readString(0, false, this.DownloadUrl);
  this.Md5 = is.readString(1, false, this.Md5);
  this.Version = is.readString(2, false, this.Version);
  this.LaunchCommand = is.readString(3, false, this.LaunchCommand);
  this.DesktopIconUrl = is.readString(4, false, this.DesktopIconUrl);
  this.CefDownloadUrl = is.readString(5, false, this.CefDownloadUrl);
  this.CefMd5 = is.readString(6, false, this.CefMd5);
  this.StartExternal = is.readInt32(7, false, this.StartExternal);
  this.lLatestUpdateTime = is.readInt64(8, false, this.lLatestUpdateTime);
};

HUYA.GetPCDownloaderbyHttpRequestRsp.prototype.writeTo = function (os) {
  os.writeString(0, this.DownloadUrl);
  os.writeString(1, this.Md5);
  os.writeString(2, this.Version);
  os.writeString(3, this.LaunchCommand);
  os.writeString(4, this.DesktopIconUrl);
  os.writeString(5, this.CefDownloadUrl);
  os.writeString(6, this.CefMd5);
  os.writeInt32(7, this.StartExternal);
  os.writeInt64(8, this.lLatestUpdateTime);
};

HUYA.GetPCDownloaderbyHttpRequestRsp.prototype._clone = function () {
  return new HUYA.GetPCDownloaderbyHttpRequestRsp();
};
HUYA.GetPCDownloaderbyHttpRequestRsp.prototype._write = function (
  os,
  tag,
  value
) {
  os.writeStruct(tag, value);
};
HUYA.GetPCDownloaderbyHttpRequestRsp.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};